"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    "abashed",
    "abbreviated",
    "abdominal",
    "abiding",
    "abject",
    "ablaze",
    "able",
    "able-bodied",
    "abnormal",
    "abominable",
    "aboriginal",
    "above",
    "abrasive",
    "abreast",
    "abrupt",
    "absent",
    "absolute",
    "absorbed",
    "absorbing",
    "abstract",
    "abundant",
    "academic",
    "accelerated",
    "accelerating",
    "acceptable",
    "accepted",
    "accessible",
    "accidental",
    "accompanying",
    "accomplished",
    "accountable",
    "accumulated",
    "accurate",
    "accursed",
    "accused",
    "accustomed",
    "aching",
    "acknowledged",
    "acoustic",
    "acquired",
    "acquisitive",
    "acrid",
    "acrimonious",
    "across-the-board",
    "acting",
    "active",
    "actual",
    "acute",
    "adamant",
    "adaptable",
    "adaptive",
    "added",
    "addictive",
    "additional",
    "additive",
    "adept",
    "adequate",
    "adhesive",
    "adjacent",
    "adjoining",
    "adjustable",
    "administrative",
    "admirable",
    "admiring",
    "admitting",
    "adolescent",
    "adopted",
    "adorable",
    "adoring",
    "adrenal",
    "adrift",
    "adroit",
    "adult",
    "advanced",
    "advancing",
    "advantageous",
    "adventurous",
    "adverse",
    "advisable",
    "advisory",
    "aesthetic",
    "affable",
    "affected",
    "affectionate",
    "affiliated",
    "affirmative",
    "afflicted",
    "affluent",
    "affordable",
    "afire",
    "afloat",
    "afraid",
    "aft",
    "after",
    "afterward",
    "aged",
    "ageless",
    "aggravated",
    "aggregate",
    "aghast",
    "agile",
    "aging",
    "agitated",
    "agonized",
    "agonizing",
    "agrarian",
    "agreeable",
    "agreed",
    "agricultural",
    "ailing",
    "aimless",
    "air-conditioned",
    "air-conditioning",
    "airborne",
    "airless",
    "airtight",
    "airy",
    "ajar",
    "akin",
    "alarmed",
    "alarming",
    "alert",
    "alien",
    "alienated",
    "alike",
    "alive",
    "all-american",
    "all-important",
    "all-night",
    "all-out",
    "all-powerful",
    "all-purpose",
    "all-time",
    "all-white",
    "alleged",
    "allegorical",
    "allergic",
    "allied",
    "allowable",
    "alluring",
    "almighty",
    "alone",
    "aloof",
    "alright",
    "altered",
    "alternate",
    "alternating",
    "alternative",
    "amateur",
    "amateurish",
    "amazed",
    "amazing",
    "amber",
    "ambiguous",
    "ambitious",
    "ambivalent",
    "amenable",
    "amiable",
    "amorous",
    "amorphous",
    "ample",
    "amused",
    "amusing",
    "anachronistic",
    "anal",
    "analogous",
    "analytic",
    "analytical",
    "anarchic",
    "anatomical",
    "ancestral",
    "ancient",
    "anemic",
    "anesthetic",
    "angelic",
    "angry",
    "anguished",
    "angular",
    "animated",
    "announced",
    "annoying",
    "annual",
    "anonymous",
    "answering",
    "antagonistic",
    "anterior",
    "anthropological",
    "anti",
    "anti-american",
    "anti-inflation",
    "anti-soviet",
    "anticipated",
    "antinuclear",
    "antiquated",
    "antique",
    "antiseptic",
    "antitank",
    "anxious",
    "apathetic",
    "apocalyptic",
    "apolitical",
    "appalled",
    "appalling",
    "apparent",
    "appealing",
    "appellate",
    "applicable",
    "applied",
    "appointed",
    "appreciable",
    "appreciative",
    "apprehensive",
    "approaching",
    "appropriate",
    "approved",
    "approximate",
    "apt",
    "aquatic",
    "arbitrary",
    "arcane",
    "arch",
    "archaeological",
    "archaic",
    "arched",
    "archetypal",
    "architectural",
    "arctic",
    "ardent",
    "arduous",
    "arid",
    "aristocratic",
    "armed",
    "armored",
    "arms-control",
    "aromatic",
    "arresting",
    "arterial",
    "artful",
    "articulate",
    "articulated",
    "artificial",
    "artistic",
    "ascending",
    "ascetic",
    "ascorbic",
    "ashamed",
    "ashen",
    "askew",
    "asleep",
    "aspiring",
    "assembled",
    "assertive",
    "assigned",
    "assistant",
    "associate",
    "associated",
    "assorted",
    "assumed",
    "assured",
    "astonished",
    "astonishing",
    "astounded",
    "astounding",
    "astronomical",
    "astute",
    "athletic",
    "atmospheric",
    "atomic",
    "atrocious",
    "attached",
    "attacking",
    "attainable",
    "attempted",
    "attendant",
    "attentive",
    "attracting",
    "attractive",
    "attributable",
    "auburn",
    "audacious",
    "audible",
    "audio",
    "auditory",
    "august",
    "auspicious",
    "austere",
    "authentic",
    "authoritarian",
    "authoritative",
    "authorized",
    "autobiographical",
    "autocratic",
    "automated",
    "automatic",
    "automotive",
    "autonomous",
    "autumnal",
    "auxiliary",
    "available",
    "avant-garde",
    "avenging",
    "average",
    "averse",
    "avid",
    "avowed",
    "awake",
    "aware",
    "awash",
    "away",
    "awed",
    "awesome",
    "back",
    "backhand",
    "backstage",
    "backward",
    "bacterial",
    "baffled",
    "baffling",
    "baggy",
    "baked",
    "balanced",
    "bald",
    "balding",
    "baleful",
    "ballistic",
    "balmy",
    "banal",
    "bankrupt",
    "banned",
    "barbarous",
    "barbed",
    "bare",
    "barefoot",
    "barefooted",
    "barred",
    "barren",
    "basic",
    "bass",
    "bathing",
    "battered",
    "beaded",
    "beaming",
    "bearable",
    "bearded",
    "beastly",
    "beautiful",
    "bedraggled",
    "beefy",
    "befuddled",
    "beguiling",
    "behavioral",
    "behind-the-scenes",
    "beige",
    "belated",
    "beleaguered",
    "believable",
    "belligerent",
    "beloved",
    "bemused",
    "beneficent",
    "beneficial",
    "benign",
    "bent",
    "bereaved",
    "bereft",
    "bespectacled",
    "best-known",
    "best-selling",
    "bestselling",
    "bewildered",
    "bewildering",
    "big",
    "big-city",
    "big-time",
    "bilateral",
    "bilingual",
    "binary",
    "binding",
    "biochemical",
    "biographical",
    "biological",
    "bipartisan",
    "biting",
    "bitter",
    "bittersweet",
    "bizarre",
    "black",
    "black-and-white",
    "black-haired",
    "blackened",
    "bland",
    "blank",
    "blasted",
    "blatant",
    "blazing",
    "bleached",
    "bleak",
    "bleary",
    "bleeding",
    "blessed",
    "blind",
    "blinding",
    "blinking",
    "blissful",
    "blistering",
    "bloated",
    "blocking",
    "blond",
    "blonde",
    "bloodied",
    "bloodshot",
    "bloodstained",
    "bloody",
    "blooming",
    "blue",
    "blue-and-white",
    "blue-black",
    "blue-chip",
    "blue-collar",
    "blue-eyed",
    "blue-gray",
    "blue-green",
    "bluish",
    "blunt",
    "blurred",
    "bodily",
    "bogus",
    "boiled",
    "boiling",
    "boisterous",
    "bold",
    "bony",
    "booming",
    "bored",
    "boring",
    "born",
    "born-again",
    "borrowed",
    "botanical",
    "bottled",
    "bottom",
    "bottomless",
    "bouncing",
    "bound",
    "boundless",
    "bountiful",
    "bourgeois",
    "bowed",
    "box-office",
    "boyish",
    "bracing",
    "braided",
    "branching",
    "brand-new",
    "brash",
    "brassy",
    "brave",
    "brawny",
    "brazen",
    "breathless",
    "breathtaking",
    "breezy",
    "bridal",
    "brief",
    "bright",
    "bright-eyed",
    "brilliant",
    "brisk",
    "brittle",
    "broad",
    "broad-shouldered",
    "broke",
    "broken",
    "bronchial",
    "brooding",
    "brotherly",
    "brown",
    "brownish",
    "bruised",
    "brusque",
    "brutal",
    "bubbling",
    "bubbly",
    "budding",
    "budgetary",
    "bulbous",
    "bulging",
    "bulky",
    "bulletproof",
    "bumper",
    "bumpy",
    "buoyant",
    "burdensome",
    "bureaucratic",
    "burgeoning",
    "buried",
    "burly",
    "burned",
    "burned-out",
    "burning",
    "burnished",
    "burnt",
    "bushy",
    "businesslike",
    "busing",
    "busted",
    "bustling",
    "busy",
    "button-down",
    "buxom",
    "buzzing",
    "bygone",
    "caged",
    "calculated",
    "called",
    "callous",
    "calm",
    "cancerous",
    "candid",
    "canned",
    "canny",
    "cantankerous",
    "capable",
    "capital",
    "capitalist",
    "capitalistic",
    "capricious",
    "captive",
    "cardboard",
    "cardiac",
    "cardinal",
    "cardiovascular",
    "carefree",
    "careful",
    "careless",
    "caring",
    "carnival",
    "carpeted",
    "carved",
    "cast",
    "cast-iron",
    "casual",
    "catastrophic",
    "causal",
    "caustic",
    "cautionary",
    "cautious",
    "cavernous",
    "ceaseless",
    "celebrated",
    "celestial",
    "cellular",
    "centennial",
    "central",
    "centralized",
    "centre-fire",
    "centrifugal",
    "centrist",
    "ceramic",
    "cerebral",
    "ceremonial",
    "certain",
    "certified",
    "challenging",
    "change-minimizing",
    "changed",
    "changing",
    "chaotic",
    "characteristic",
    "charged",
    "charging",
    "charismatic",
    "charitable",
    "charming",
    "charred",
    "chartered",
    "chaste",
    "chastened",
    "cheap",
    "checked",
    "checkered",
    "cheerful",
    "cheering",
    "cheery",
    "chemical",
    "cherished",
    "chief",
    "childlike",
    "chilled",
    "chilling",
    "chilly",
    "chipped",
    "chopped",
    "choppy",
    "choral",
    "chosen",
    "chronic",
    "chronological",
    "chunky",
    "cinematic",
    "circular",
    "circulating",
    "circulatory",
    "circumstantial",
    "citywide",
    "civic",
    "civil",
    "civilian",
    "civilized",
    "clammy",
    "clandestine",
    "classic",
    "classical",
    "classified",
    "classy",
    "clean",
    "clean-cut",
    "clear",
    "clear-cut",
    "cleared",
    "clearing",
    "clenched",
    "clerical",
    "clever",
    "climactic",
    "climatic",
    "clinging",
    "clinical",
    "clipped",
    "close",
    "closed",
    "closed-circuit",
    "closing",
    "cloudless",
    "cloudy",
    "clumsy",
    "cluttered",
    "coarse",
    "coastal",
    "cobbled",
    "coded",
    "coed",
    "coercive",
    "cognitive",
    "coherent",
    "cohesive",
    "coiled",
    "coincidental",
    "cold",
    "cold-blooded",
    "collaborative",
    "collapsing",
    "collected",
    "collective",
    "collegiate",
    "colonial",
    "colored",
    "colorful",
    "colorless",
    "colossal",
    "coloured",
    "comatose",
    "combative",
    "combined",
    "comely",
    "comfortable",
    "comforting",
    "comic",
    "comical",
    "coming",
    "commanding",
    "commendable",
    "commensurate",
    "commercial",
    "committed",
    "common",
    "commonplace",
    "communal",
    "compact",
    "comparable",
    "comparative",
    "compassionate",
    "compatible",
    "compelling",
    "compensatory",
    "competent",
    "competing",
    "competitive",
    "complacent",
    "complementary",
    "complete",
    "completed",
    "complex",
    "compliant",
    "complicated",
    "complimentary",
    "composite",
    "compositional",
    "comprehensible",
    "comprehensive",
    "compressed",
    "compulsory",
    "computerized",
    "concave",
    "concealed",
    "conceivable",
    "concentrated",
    "concentric",
    "conceptual",
    "concerned",
    "concerted",
    "conciliatory",
    "concise",
    "concluding",
    "conclusive",
    "concomitant",
    "concrete",
    "concurrent",
    "condemned",
    "condescending",
    "conditional",
    "conditioned",
    "conducive",
    "confident",
    "confidential",
    "confined",
    "confirmed",
    "conflicting",
    "confused",
    "confusing",
    "congenial",
    "congenital",
    "congested",
    "congressional",
    "conic",
    "conical",
    "connected",
    "connecting",
    "connective",
    "conquered",
    "conquering",
    "conscientious",
    "conscious",
    "consecutive",
    "consequent",
    "conservation",
    "conservative",
    "considerable",
    "considerate",
    "consistent",
    "consoling",
    "conspicuous",
    "conspiratorial",
    "constant",
    "constitutional",
    "constructive",
    "consular",
    "consulting",
    "consuming",
    "consummate",
    "contagious",
    "contaminated",
    "contemplative",
    "contemporary",
    "contemptible",
    "contemptuous",
    "contending",
    "content",
    "contented",
    "contentious",
    "contested",
    "continental",
    "contingent",
    "continual",
    "continued",
    "continuing",
    "continuous",
    "contraceptive",
    "contracting",
    "contractual",
    "contradictory",
    "contrary",
    "contrasting",
    "contributing",
    "contrite",
    "contrived",
    "controlled",
    "controlling",
    "controversial",
    "convenient",
    "conventional",
    "conversational",
    "converted",
    "convertible",
    "convicted",
    "convinced",
    "convincing",
    "convulsive",
    "cooked",
    "cool",
    "cooling",
    "cooperative",
    "coordinated",
    "copious",
    "cordial",
    "corned",
    "corny",
    "coronary",
    "corporate",
    "correct",
    "correctional",
    "corrective",
    "corresponding",
    "corrosive",
    "corrugated",
    "cosmetic",
    "cosmic",
    "cosmopolitan",
    "costly",
    "counterfeit",
    "counterproductive",
    "countless",
    "courageous",
    "court-ordered",
    "courteous",
    "courtly",
    "covered",
    "covert",
    "coveted",
    "coy",
    "cozy",
    "cracked",
    "cracking",
    "crackling",
    "crafty",
    "craggy",
    "cramped",
    "cranky",
    "crashing",
    "crass",
    "crawling",
    "crazed",
    "crazy",
    "creaking",
    "cream-colored",
    "creamy",
    "creased",
    "created",
    "creative",
    "credible",
    "creeping",
    "crimson",
    "crippled",
    "crisp",
    "critical",
    "cross-country",
    "cross-legged",
    "crossed",
    "crowded",
    "crucial",
    "crumbling",
    "crummy",
    "crumpled",
    "crushed",
    "crushing",
    "crusty",
    "cryptic",
    "crystalline",
    "cubic",
    "culinary",
    "cultivated",
    "cultural",
    "cultured",
    "cumbersome",
    "cumulative",
    "cunning",
    "cupped",
    "curious",
    "curled",
    "curly",
    "current",
    "cursory",
    "curt",
    "curtained",
    "curved",
    "curving",
    "customary",
    "cut-rate",
    "cute",
    "cutting",
    "cyclical",
    "cylindrical",
    "daily",
    "dainty",
    "damaged",
    "damn",
    "damned",
    "damp",
    "dangerous",
    "dank",
    "dapper",
    "daring",
    "dark",
    "dark-blue",
    "dark-eyed",
    "dark-haired",
    "darkened",
    "darkening",
    "darling",
    "darting",
    "dashing",
    "dated",
    "daunting",
    "day-care",
    "day-to-day",
    "dazed",
    "dazzling",
    "deaf",
    "deafening",
    "dear",
    "deathly",
    "debatable",
    "debilitating",
    "decadent",
    "decaying",
    "deceased",
    "decent",
    "decentralized",
    "decided",
    "decision-making",
    "decisive",
    "declared",
    "declining",
    "decorated",
    "decorative",
    "decorous",
    "decreased",
    "decreasing",
    "decrepit",
    "dedicated",
    "deductible",
    "deep",
    "deep-seated",
    "deepening",
    "defeated",
    "defenseless",
    "defensible",
    "defensive",
    "deferential",
    "deferred",
    "defiant",
    "deficient",
    "definite",
    "definitive",
    "deformed",
    "deft",
    "defunct",
    "degenerate",
    "degenerative",
    "dejected",
    "delayed",
    "delectable",
    "deliberate",
    "delicate",
    "delicious",
    "delighted",
    "delightful",
    "delinquent",
    "delirious",
    "demanding",
    "demeaning",
    "demented",
    "democratic",
    "demographic",
    "demonic",
    "demure",
    "dense",
    "dental",
    "departed",
    "departing",
    "departmental",
    "dependable",
    "dependent",
    "depleted",
    "deplorable",
    "deposed",
    "depressed",
    "derelict",
    "derisive",
    "descending",
    "descriptive",
    "deserted",
    "deserving",
    "designated",
    "desirable",
    "desired",
    "desolate",
    "despairing",
    "desperate",
    "despicable",
    "despised",
    "despondent",
    "destitute",
    "destructive",
    "desultory",
    "detached",
    "detailed",
    "detectable",
    "deteriorating",
    "determined",
    "determining",
    "detrimental",
    "devastating",
    "developed",
    "developing",
    "developmental",
    "deviant",
    "devious",
    "devoid",
    "devoted",
    "devout",
    "diagnostic",
    "diagonal",
    "dialectical",
    "dictatorial",
    "dietary",
    "different",
    "differential",
    "differing",
    "diffident",
    "diffuse",
    "digestive",
    "digging",
    "digital",
    "dignified",
    "dilapidated",
    "diligent",
    "dim",
    "diminished",
    "diminishing",
    "diminutive",
    "dingy",
    "diplomatic",
    "dire",
    "direct",
    "disabled",
    "disappearing",
    "disappointing",
    "disapproving",
    "disastrous",
    "discarded",
    "discernible",
    "discerning",
    "disciplinary",
    "disciplined",
    "disconcerting",
    "discontented",
    "discordant",
    "discouraging",
    "discredited",
    "discreet",
    "discrete",
    "discretionary",
    "discriminatory",
    "disembodied",
    "disenchanted",
    "disguised",
    "disjointed",
    "dismayed",
    "disorderly",
    "disorganized",
    "disoriented",
    "disparate",
    "displaced",
    "displeased",
    "disposable",
    "disproportionate",
    "disputed",
    "disquieting",
    "disreputable",
    "disruptive",
    "dissenting",
    "dissident",
    "dissimilar",
    "distant",
    "distinct",
    "distinctive",
    "distinguishable",
    "distinguished",
    "distinguishing",
    "distorted",
    "distraught",
    "distressed",
    "distressing",
    "disturbed",
    "disturbing",
    "divergent",
    "diverse",
    "diversified",
    "divided",
    "dividing",
    "divine",
    "diving",
    "divisional",
    "divisive",
    "dizzy",
    "dizzying",
    "do-it-yourself",
    "docile",
    "doctoral",
    "doctrinaire",
    "doctrinal",
    "dogged",
    "dogmatic",
    "domed",
    "domestic",
    "doomed",
    "door-to-door",
    "dormant",
    "double",
    "double-action",
    "double-breasted",
    "double-digit",
    "doubtful",
    "dour",
    "down",
    "down-to-earth",
    "downcast",
    "downhill",
    "downright",
    "downtown",
    "downward",
    "drab",
    "drained",
    "dramatic",
    "drastic",
    "dreaded",
    "dreamlike",
    "dreamy",
    "dreary",
    "dried",
    "driven",
    "driving",
    "droll",
    "drooping",
    "drowning",
    "drowsy",
    "drugged",
    "drunken",
    "dry",
    "dual",
    "dubious",
    "due",
    "dull",
    "duplicate",
    "durable",
    "dusky",
    "dusty",
    "dutiful",
    "dwindling",
    "dyed",
    "dying",
    "dynamic",
    "dynastic",
    "eager",
    "early",
    "early-morning",
    "earned",
    "earnest",
    "earthen",
    "earthly",
    "earthy",
    "eastern",
    "easy",
    "easygoing",
    "ebullient",
    "eccentric",
    "ecclesiastical",
    "echoing",
    "eclectic",
    "ecological",
    "economic",
    "economical",
    "ecstatic",
    "ecumenical",
    "edgy",
    "edible",
    "editorial",
    "educated",
    "educational",
    "eerie",
    "effective",
    "efficient",
    "effortless",
    "egalitarian",
    "eight-hour",
    "eight-year",
    "eighteenth-century",
    "elaborate",
    "elastic",
    "elated",
    "elderly",
    "elected",
    "elective",
    "electoral",
    "electric",
    "electrical",
    "electromagnetic",
    "electronic",
    "electrostatic",
    "elegant",
    "elemental",
    "elementary",
    "elevated",
    "eligible",
    "elitist",
    "elongated",
    "eloquent",
    "elusive",
    "embarrassed",
    "embarrassing",
    "embattled",
    "emblematic",
    "embroidered",
    "embryonic",
    "emerging",
    "emeritus",
    "eminent",
    "emotional",
    "emphatic",
    "empirical",
    "empty",
    "empty-handed",
    "enchanted",
    "enchanting",
    "enclosed",
    "encouraging",
    "endangered",
    "endearing",
    "endemic",
    "endless",
    "enduring",
    "energetic",
    "enforced",
    "engaged",
    "engaging",
    "engraved",
    "enhanced",
    "enigmatic",
    "enjoyable",
    "enlarged",
    "enlightened",
    "enormous",
    "enraged",
    "enriched",
    "ensconced",
    "ensuing",
    "enterprising",
    "entertaining",
    "enthusiastic",
    "enticing",
    "entire",
    "entrenched",
    "entrepreneurial",
    "enviable",
    "envious",
    "environmental",
    "ephemeral",
    "epic",
    "equal",
    "equatorial",
    "equestrian",
    "equitable",
    "equivalent",
    "eroding",
    "errant",
    "erratic",
    "erroneous",
    "ersatz",
    "erstwhile",
    "escalating",
    "escaping",
    "esoteric",
    "essential",
    "established",
    "esteemed",
    "esthetic",
    "estimated",
    "estranged",
    "eternal",
    "ethereal",
    "ethical",
    "eucalyptus",
    "euphoric",
    "evangelical",
    "evasive",
    "even",
    "eventual",
    "ever-increasing",
    "ever-present",
    "everlasting",
    "everyday",
    "evident",
    "evocative",
    "evolutionary",
    "exact",
    "exacting",
    "exaggerated",
    "exalted",
    "excellent",
    "exceptional",
    "excess",
    "excessive",
    "excited",
    "exciting",
    "exclusive",
    "excruciating",
    "executive",
    "exemplary",
    "exempt",
    "exhausted",
    "exhausting",
    "exhaustive",
    "exhilarated",
    "exhilarating",
    "exiled",
    "existential",
    "existing",
    "exorbitant",
    "exotic",
    "expanded",
    "expanding",
    "expansive",
    "expectant",
    "expected",
    "expedient",
    "expendable",
    "expensive",
    "experienced",
    "experimental",
    "expert",
    "explanatory",
    "explicit",
    "exploratory",
    "explosive",
    "exposed",
    "express",
    "expressed",
    "expressionless",
    "expressive",
    "exquisite",
    "extant",
    "extended",
    "extensive",
    "exterior",
    "external",
    "extinct",
    "extra",
    "extracurricular",
    "extraneous",
    "extraordinary",
    "extravagant",
    "extreme",
    "extremist",
    "extrinsic",
    "exuberant",
    "exultant",
    "fabled",
    "fabulous",
    "face-to-face",
    "faceless",
    "facial",
    "facile",
    "factional",
    "factual",
    "faded",
    "fading",
    "failed",
    "failing",
    "faint",
    "fair",
    "faithful",
    "fallen",
    "falling",
    "fallow",
    "false",
    "faltering",
    "famed",
    "familial",
    "familiar",
    "famished",
    "famous",
    "fanatical",
    "fanciful",
    "fancy",
    "fantastic",
    "far-flung",
    "far-off",
    "far-reaching",
    "farcical",
    "farfetched",
    "fascinated",
    "fascinating",
    "fascist",
    "fashionable",
    "fast",
    "fast-food",
    "fast-growing",
    "fast-moving",
    "fastidious",
    "fatal",
    "fated",
    "fateful",
    "fatherly",
    "fatty",
    "fatuous",
    "faulty",
    "favorable",
    "favored",
    "favorite",
    "favourable",
    "favourite",
    "feal",
    "fearful",
    "fearless",
    "fearsome",
    "feasible",
    "feathered",
    "feathery",
    "featureless",
    "federal",
    "feeble",
    "feeding",
    "feisty",
    "fellow",
    "feminine",
    "ferocious",
    "fervent",
    "festive",
    "fetal",
    "fetid",
    "feudal",
    "feverish",
    "fickle",
    "fictional",
    "fictitious",
    "fierce",
    "fiery",
    "figurative",
    "filmy",
    "final",
    "financial",
    "fine",
    "finished",
    "finishing",
    "finite",
    "firm",
    "first-aid",
    "first-class",
    "first-quarter",
    "first-rate",
    "first-time",
    "first-year",
    "firsthand",
    "fiscal",
    "fishy",
    "fit",
    "fitful",
    "fitting",
    "five-day",
    "five-minute",
    "five-year",
    "fixed",
    "flabbergasted",
    "flabby",
    "flagrant",
    "flailing",
    "flaky",
    "flamboyant",
    "flaming",
    "flash",
    "flashing",
    "flashy",
    "flat",
    "flattened",
    "flattered",
    "flattering",
    "flawless",
    "fledgling",
    "fleeing",
    "fleeting",
    "fleshy",
    "flexible",
    "flickering",
    "flimsy",
    "flipping",
    "floating",
    "floppy",
    "floral",
    "florid",
    "flourishing",
    "flowered",
    "flowering",
    "flowery",
    "flowing",
    "fluent",
    "fluffy",
    "fluorescent",
    "flushed",
    "flustered",
    "fluted",
    "fluttering",
    "flying",
    "foaming",
    "focal",
    "foggy",
    "folded",
    "folding",
    "follow-up",
    "following",
    "fond",
    "foolhardy",
    "foolish",
    "forbidding",
    "forced",
    "forceful",
    "foregoing",
    "foreign",
    "foreign-policy",
    "forensic",
    "foreseeable",
    "forested",
    "forged",
    "forgiving",
    "forgotten",
    "forlorn",
    "formal",
    "formative",
    "formidable",
    "formless",
    "forthcoming",
    "forthright",
    "fortified",
    "fortuitous",
    "fortunate",
    "forward",
    "foster",
    "foul",
    "founding",
    "four-day",
    "four-hour",
    "four-year",
    "fourth-quarter",
    "fractured",
    "fragmentary",
    "fragmented",
    "fragrant",
    "frail",
    "framed",
    "frank",
    "frantic",
    "fraternal",
    "fraudulent",
    "fraught",
    "frayed",
    "freak",
    "freckled",
    "free",
    "free-lance",
    "freezing",
    "french",
    "frenetic",
    "frenzied",
    "frequent",
    "fresh",
    "freshwater",
    "fretful",
    "friendly",
    "frightened",
    "frightening",
    "frightful",
    "frigid",
    "fringed",
    "frivolous",
    "front",
    "front-line",
    "front-page",
    "frontal",
    "frosted",
    "frosty",
    "frozen",
    "fruitful",
    "fruitless",
    "frustrated",
    "frustrating",
    "full",
    "full-blown",
    "full-fledged",
    "full-length",
    "full-page",
    "full-scale",
    "full-size",
    "full-time",
    "fun",
    "functional",
    "functioning",
    "fund-raising",
    "fundamental",
    "fundamentalist",
    "funded",
    "funky",
    "funny",
    "furious",
    "furnished",
    "furry",
    "furtive",
    "fussy",
    "futile",
    "future",
    "futuristic",
    "fuzzy",
    "galactic",
    "gallant",
    "galloping",
    "galvanized",
    "gaping",
    "garbled",
    "gargantuan",
    "garish",
    "garrulous",
    "gaseous",
    "gastrointestinal",
    "gathered",
    "gaudy",
    "gaunt",
    "gebling",
    "general",
    "generalized",
    "generating",
    "generative",
    "generic",
    "generous",
    "genetic",
    "genital",
    "genteel",
    "gentle",
    "gentlemanly",
    "genuine",
    "geographic",
    "geographical",
    "geological",
    "geometric",
    "geopolitical",
    "ghastly",
    "ghostly",
    "giant",
    "gibberish",
    "giddy",
    "gifted",
    "gigantic",
    "gilded",
    "ginger",
    "girlish",
    "given",
    "glacial",
    "glad",
    "glamorous",
    "glaring",
    "glassy",
    "glazed",
    "gleaming",
    "gleeful",
    "glib",
    "glistening",
    "glittering",
    "global",
    "gloomy",
    "glorious",
    "glossy",
    "gloved",
    "glowing",
    "glum",
    "gnarled",
    "goddam",
    "goddamn",
    "goddamned",
    "going",
    "gold",
    "golden",
    "good",
    "good-by",
    "good-looking",
    "good-natured",
    "good-sized",
    "goodly",
    "gorgeous",
    "gory",
    "governing",
    "governmental",
    "graceful",
    "gracious",
    "gradual",
    "grainy",
    "grammatical",
    "grand",
    "grandiose",
    "graphic",
    "grassy",
    "grateful",
    "gratifying",
    "grating",
    "gratuitous",
    "grave",
    "gravitational",
    "gray",
    "gray-haired",
    "graying",
    "grayish",
    "grazing",
    "greasy",
    "great",
    "greedy",
    "green",
    "greenish",
    "gregarious",
    "grey",
    "grieving",
    "grievous",
    "grilled",
    "grim",
    "grimy",
    "grinding",
    "grinning",
    "gripping",
    "grisly",
    "gritty",
    "grizzled",
    "grizzly",
    "groggy",
    "grotesque",
    "ground",
    "ground-floor",
    "growing",
    "grown-up",
    "grubby",
    "grudging",
    "grueling",
    "gruesome",
    "gruff",
    "guaranteed",
    "guarded",
    "gubernatorial",
    "guided",
    "guiding",
    "gullible",
    "guttural",
    "habitual",
    "haggard",
    "hairless",
    "hairy",
    "half-empty",
    "halfway",
    "hallowed",
    "halting",
    "hand-held",
    "hand-to-hand",
    "handicapped",
    "handmade",
    "handsome",
    "handwritten",
    "handy",
    "hanging",
    "haphazard",
    "hapless",
    "happy",
    "hard",
    "hard-boiled",
    "hard-core",
    "hard-line",
    "hard-nosed",
    "hard-pressed",
    "hard-working",
    "hardened",
    "hardworking",
    "hardy",
    "harmless",
    "harmonious",
    "harried",
    "harrowing",
    "harsh",
    "hashish",
    "hasty",
    "hated",
    "hateful",
    "haughty",
    "haunted",
    "haunting",
    "hawkish",
    "hazardous",
    "hazel",
    "hazy",
    "head",
    "headlong",
    "heady",
    "healing",
    "healthful",
    "healthy",
    "heart-shaped",
    "heartbreaking",
    "heartening",
    "heartfelt",
    "heartless",
    "hearty",
    "heated",
    "heathen",
    "heavenly",
    "heavy",
    "heavy-duty",
    "hectic",
    "heedless",
    "hefty",
    "heightened",
    "helmeted",
    "helpful",
    "hereditary",
    "heretical",
    "heroic",
    "hesitant",
    "heterogeneous",
    "hidden",
    "hierarchical",
    "high",
    "high-ceilinged",
    "high-fiber",
    "high-heeled",
    "high-level",
    "high-pitched",
    "high-powered",
    "high-pressure",
    "high-priced",
    "high-quality",
    "high-ranking",
    "high-rise",
    "high-risk",
    "high-school",
    "high-speed",
    "high-tech",
    "high-technology",
    "hilarious",
    "hilly",
    "hind",
    "hired",
    "historic",
    "historical",
    "hit-and-run",
    "hoarse",
    "holding",
    "hollow",
    "holy",
    "homeless",
    "homemade",
    "homesick",
    "honest",
    "honorable",
    "honorary",
    "honored",
    "hooded",
    "hopeful",
    "hopeless",
    "horizontal",
    "hormonal",
    "horn-rimmed",
    "horrendous",
    "horrible",
    "horrid",
    "horrified",
    "horse-drawn",
    "hospitable",
    "hot",
    "hour-long",
    "hourly",
    "howling",
    "huge",
    "hulking",
    "human",
    "humane",
    "humanistic",
    "humanitarian",
    "humble",
    "humid",
    "humiliating",
    "humorless",
    "humorous",
    "hunched",
    "hungry",
    "hunted",
    "hurried",
    "hurt",
    "hurtful",
    "hushed",
    "husky",
    "hybrid",
    "hydraulic",
    "hydroelectric",
    "hypnotic",
    "hypodermic",
    "hypothetical",
    "hysterical",
    "ice-cold",
    "iced",
    "icy",
    "ideal",
    "idealistic",
    "identical",
    "identifiable",
    "ideological",
    "idiosyncratic",
    "idiotic",
    "idle",
    "idyllic",
    "ignorant",
    "ill",
    "ill-advised",
    "ill-fated",
    "ill-fitting",
    "illegitimate",
    "illicit",
    "illiterate",
    "illogical",
    "illuminated",
    "illuminating",
    "illusory",
    "illustrated",
    "illustrious",
    "imaginable",
    "imaginary",
    "imaginative",
    "imagined",
    "immaculate",
    "immediate",
    "immense",
    "imminent",
    "immobile",
    "immortal",
    "immune",
    "immutable",
    "impartial",
    "impassable",
    "impassioned",
    "impassive",
    "impatient",
    "impeccable",
    "impending",
    "impenetrable",
    "imperative",
    "imperceptible",
    "imperial",
    "imperialist",
    "imperious",
    "impersonal",
    "impertinent",
    "impervious",
    "impetuous",
    "implacable",
    "implausible",
    "implicit",
    "implied",
    "important",
    "imported",
    "imposing",
    "impossible",
    "impoverished",
    "impractical",
    "imprecise",
    "impressed",
    "impressive",
    "imprisoned",
    "improbable",
    "impromptu",
    "improper",
    "improved",
    "improving",
    "improvised",
    "impulsive",
    "impure",
    "in-depth",
    "in-house",
    "inaccessible",
    "inactive",
    "inane",
    "inanimate",
    "inarticulate",
    "inaudible",
    "incalculable",
    "incandescent",
    "incapable",
    "incendiary",
    "incessant",
    "incidental",
    "incipient",
    "incisive",
    "inclined",
    "inclusive",
    "incoherent",
    "income-tax",
    "incoming",
    "incomparable",
    "incompatible",
    "incompetent",
    "incomplete",
    "incomprehensible",
    "inconceivable",
    "inconclusive",
    "incongruous",
    "inconsequential",
    "inconsistent",
    "inconspicuous",
    "incorrect",
    "increased",
    "increasing",
    "incredible",
    "incredulous",
    "incremental",
    "incriminating",
    "incumbent",
    "incurable",
    "indebted",
    "indefatigable",
    "indefinite",
    "indelible",
    "independent",
    "indestructible",
    "indeterminate",
    "indicative",
    "indifferent",
    "indigenous",
    "indigent",
    "indignant",
    "indirect",
    "indiscriminate",
    "indispensable",
    "indistinct",
    "indistinguishable",
    "individual",
    "individualistic",
    "indomitable",
    "indoor",
    "indulgent",
    "industrial",
    "industrialized",
    "industrious",
    "ineffable",
    "ineffective",
    "ineffectual",
    "inept",
    "inert",
    "inescapable",
    "inevitable",
    "inexhaustible",
    "inexorable",
    "inexpensive",
    "inexperienced",
    "inexplicable",
    "infallible",
    "infamous",
    "infantile",
    "infatuated",
    "infected",
    "infectious",
    "infernal",
    "infinite",
    "infirm",
    "inflamed",
    "inflammatory",
    "inflated",
    "inflationary",
    "inflexible",
    "influential",
    "informal",
    "informative",
    "informed",
    "infrared",
    "infrequent",
    "ingenious",
    "ingratiating",
    "inherent",
    "inherited",
    "inhospitable",
    "inimical",
    "initial",
    "injured",
    "inlaid",
    "inland",
    "innate",
    "inner",
    "inner-city",
    "innermost",
    "innocent",
    "innocuous",
    "innovative",
    "innumerable",
    "inordinate",
    "inorganic",
    "inquisitive",
    "insane",
    "inscrutable",
    "insensitive",
    "inside",
    "insignificant",
    "insistent",
    "insoluble",
    "inspirational",
    "inspired",
    "inspiring",
    "instant",
    "instantaneous",
    "instinctive",
    "institutional",
    "institutionalized",
    "instructional",
    "instructive",
    "instrumental",
    "insufferable",
    "insulated",
    "insurgent",
    "insurmountable",
    "intact",
    "intangible",
    "integral",
    "integrated",
    "intellectual",
    "intelligent",
    "intelligible",
    "intended",
    "intense",
    "intensified",
    "intensive",
    "intent",
    "intentional",
    "inter",
    "interchangeable",
    "intercontinental",
    "interdependent",
    "interested",
    "interesting",
    "interim",
    "interior",
    "interlocking",
    "intermediate",
    "intermediate-range",
    "interminable",
    "intermittent",
    "internal",
    "international",
    "interpersonal",
    "interrelated",
    "interstate",
    "interstellar",
    "intervening",
    "intimidating",
    "intolerable",
    "intolerant",
    "intractable",
    "intransigent",
    "intravenous",
    "intrepid",
    "intricate",
    "intriguing",
    "intrinsic",
    "introductory",
    "intrusive",
    "intuitive",
    "invading",
    "invalid",
    "invaluable",
    "inventive",
    "inverted",
    "investigative",
    "investing",
    "invigorating",
    "invincible",
    "invisible",
    "inviting",
    "involuntary",
    "involved",
    "invulnerable",
    "inward",
    "irate",
    "iridescent",
    "ironic",
    "irrational",
    "irregular",
    "irrelevant",
    "irreparable",
    "irreplaceable",
    "irrepressible",
    "irresistible",
    "irresponsible",
    "irreverent",
    "irreversible",
    "irrevocable",
    "irritable",
    "irritated",
    "irritating",
    "isolated",
    "issuing",
    "itinerant",
    "jaded",
    "jagged",
    "jaunty",
    "jerky",
    "jeweled",
    "jittery",
    "joint",
    "jolly",
    "journalistic",
    "jovial",
    "joyful",
    "joyous",
    "jubilant",
    "judicial",
    "judicious",
    "juicy",
    "jumbo",
    "jumping",
    "jumpy",
    "junior",
    "just",
    "justifiable",
    "justified",
    "keen",
    "khaki",
    "kind",
    "kindly",
    "kindred",
    "kinetic",
    "kinky",
    "knitted",
    "knotted",
    "knowing",
    "knowledgeable",
    "known",
    "kosher",
    "labored",
    "laborious",
    "laconic",
    "lacy",
    "lame",
    "land-based",
    "landed",
    "landless",
    "languid",
    "lanky",
    "large",
    "large-scale",
    "lascivious",
    "last-minute",
    "lasting",
    "late",
    "late-night",
    "latent",
    "lateral",
    "latter-day",
    "laughable",
    "laughing",
    "lavish",
    "law-abiding",
    "law-enforcement",
    "lawful",
    "lawless",
    "lax",
    "lay",
    "lazy",
    "leaded",
    "leaden",
    "leading",
    "leafless",
    "leafy",
    "leaky",
    "lean",
    "learned",
    "leathery",
    "leery",
    "left",
    "left-hand",
    "left-handed",
    "left-wing",
    "leftover",
    "legal",
    "legendary",
    "legislative",
    "legitimate",
    "leisurely",
    "lengthy",
    "lenient",
    "lesser",
    "lethal",
    "level",
    "leveraged",
    "lexical",
    "liable",
    "liberal",
    "liberated",
    "liberating",
    "licensed",
    "life-size",
    "lifeless",
    "lifelong",
    "light",
    "lighted",
    "lightweight",
    "likable",
    "like",
    "likely",
    "limited",
    "limiting",
    "limitless",
    "limp",
    "linear",
    "lined",
    "lingering",
    "linguistic",
    "linked",
    "liquid",
    "listed",
    "listening",
    "listless",
    "literal",
    "literary",
    "literate",
    "lithe",
    "little",
    "little-known",
    "liturgical",
    "live",
    "lively",
    "livid",
    "living",
    "living-room",
    "loaded",
    "loathsome",
    "local",
    "locked",
    "lofty",
    "logical",
    "logistical",
    "lone",
    "lonely",
    "lonesome",
    "long",
    "long-awaited",
    "long-distance",
    "long-haired",
    "long-legged",
    "long-lost",
    "long-range",
    "long-running",
    "long-standing",
    "long-term",
    "long-time",
    "longstanding",
    "longterm",
    "longtime",
    "looking",
    "looming",
    "loose",
    "lopsided",
    "lordly",
    "losing",
    "loud",
    "lousy",
    "lovable",
    "loved",
    "lovely",
    "loving",
    "low",
    "low-cost",
    "low-income",
    "low-key",
    "low-level",
    "lower-class",
    "lowered",
    "lowly",
    "loyal",
    "lucid",
    "lucky",
    "lucrative",
    "ludicrous",
    "lukewarm",
    "lumbering",
    "luminous",
    "lunar",
    "lunatic",
    "lurid",
    "lurking",
    "luscious",
    "lush",
    "luxuriant",
    "luxurious",
    "luxury",
    "lyric",
    "lyrical",
    "macabre",
    "machine-gun",
    "macho",
    "mad",
    "magic",
    "magical",
    "magnetic",
    "magnificent",
    "maiden",
    "maimed",
    "main",
    "mainstream",
    "majestic",
    "major",
    "makeshift",
    "malevolent",
    "malignant",
    "mammoth",
    "man-made",
    "manageable",
    "managerial",
    "managing",
    "mandatory",
    "maniacal",
    "manic",
    "manicured",
    "manifest",
    "manifold",
    "manipulative",
    "manly",
    "manned",
    "manual",
    "manufactured",
    "marching",
    "marginal",
    "marine",
    "maritime",
    "marked",
    "marketable",
    "maroon",
    "married",
    "marshy",
    "martial",
    "marvellous",
    "marvelous",
    "masculine",
    "mashed",
    "masked",
    "mass",
    "mass-produced",
    "massed",
    "massive",
    "masterful",
    "masterly",
    "matched",
    "matching",
    "material",
    "materialistic",
    "maternal",
    "mathematical",
    "mating",
    "matter-of-fact",
    "mature",
    "maudlin",
    "mauve",
    "maximum",
    "mayoral",
    "meager",
    "meaningful",
    "meaningless",
    "measurable",
    "measured",
    "measuring",
    "meaty",
    "mechanical",
    "mechanized",
    "median",
    "medical",
    "medicinal",
    "medieval",
    "mediocre",
    "meditative",
    "medium",
    "medium-size",
    "medium-sized",
    "meek",
    "melancholy",
    "mellow",
    "melodic",
    "melodramatic",
    "melted",
    "memorable",
    "menacing",
    "menial",
    "mental",
    "mercantile",
    "merciful",
    "merciless",
    "mercurial",
    "mere",
    "merry",
    "messy",
    "metabolic",
    "metallic",
    "metaphoric",
    "metaphorical",
    "metaphysical",
    "methodical",
    "methodological",
    "meticulous",
    "metric",
    "metropolitan",
    "microscopic",
    "middle",
    "middle-aged",
    "middle-class",
    "middle-income",
    "midwestern",
    "mighty",
    "migratory",
    "mild",
    "mild-mannered",
    "militant",
    "military",
    "military-industrial",
    "milky",
    "million-dollar",
    "mindful",
    "mindless",
    "mingled",
    "miniature",
    "minimal",
    "minimum",
    "ministerial",
    "mint",
    "minuscule",
    "minute",
    "miraculous",
    "mirrored",
    "miscellaneous",
    "mischievous",
    "misguided",
    "misleading",
    "misplaced",
    "missed",
    "misshapen",
    "missing",
    "mistaken",
    "misty",
    "mixed",
    "mobile",
    "mock",
    "mocking",
    "moderate",
    "modern",
    "modern-day",
    "modernist",
    "modest",
    "modified",
    "moist",
    "molecular",
    "molten",
    "momentary",
    "momentous",
    "monastic",
    "monetary",
    "monogrammed",
    "monolithic",
    "monotonous",
    "monstrous",
    "monthly",
    "monumental",
    "moody",
    "moonlit",
    "moot",
    "moral",
    "morbid",
    "morose",
    "mortal",
    "mossy",
    "motionless",
    "motivated",
    "motley",
    "mottled",
    "mountainous",
    "mounted",
    "mounting",
    "mournful",
    "movable",
    "moving",
    "muddled",
    "muddy",
    "muffled",
    "multicolored",
    "multilateral",
    "multinational",
    "multiple",
    "mundane",
    "municipal",
    "murdered",
    "murderous",
    "murky",
    "muscular",
    "mushy",
    "musical",
    "musty",
    "mute",
    "muted",
    "mutilated",
    "mutual",
    "mysterious",
    "mystic",
    "mystical",
    "mystified",
    "mythic",
    "mythical",
    "mythological",
    "nagging",
    "naive",
    "named",
    "nameless",
    "narrative",
    "narrow",
    "nasal",
    "national",
    "nationalist",
    "nationalistic",
    "nationalized",
    "nationwide",
    "native",
    "natural",
    "naturalistic",
    "nauseous",
    "nautical",
    "naval",
    "near",
    "nearby",
    "neat",
    "nebulous",
    "necessary",
    "needful",
    "needless",
    "needy",
    "negative",
    "negligent",
    "negligible",
    "negotiable",
    "negotiated",
    "neighboring",
    "nervous",
    "neural",
    "neurological",
    "neurotic",
    "neutral",
    "never-ending",
    "new",
    "new-found",
    "newborn",
    "newfound",
    "newsworthy",
    "next-door",
    "nice",
    "nightly",
    "nightmarish",
    "nimble",
    "nineteenth-century",
    "no-fault",
    "no-nonsense",
    "noble",
    "nocturnal",
    "noisy",
    "nomadic",
    "nominal",
    "non-communist",
    "nonaligned",
    "nondescript",
    "nonexistent",
    "nonpartisan",
    "nonpolitical",
    "nonprofit",
    "nonstop",
    "normal",
    "normative",
    "northeastern",
    "northern",
    "northwestern",
    "nostalgic",
    "notable",
    "noted",
    "noteworthy",
    "noticeable",
    "notorious",
    "novel",
    "noxious",
    "nuclear",
    "numb",
    "numbered",
    "numerical",
    "numerous",
    "nursing",
    "nutritional",
    "nutritious",
    "nuts",
    "nutty",
    "obedient",
    "obese",
    "objectionable",
    "objective",
    "obligatory",
    "obliging",
    "oblique",
    "oblivious",
    "obnoxious",
    "obscure",
    "observable",
    "observant",
    "observed",
    "obsessive",
    "obsolete",
    "obstinate",
    "obvious",
    "occasional",
    "occupational",
    "occupied",
    "octagonal",
    "odd",
    "odious",
    "off",
    "off-duty",
    "offbeat",
    "offending",
    "offhand",
    "official",
    "offshore",
    "oil-producing",
    "oil-rich",
    "oily",
    "old",
    "old-fashioned",
    "old-line",
    "old-time",
    "olive",
    "ominous",
    "omnipotent",
    "omnipresent",
    "oncoming",
    "one-day",
    "one-man",
    "one-party",
    "one-room",
    "one-sided",
    "one-story",
    "one-time",
    "one-way",
    "one-year",
    "onerous",
    "onetime",
    "ongoing",
    "only",
    "onstage",
    "opaque",
    "open",
    "open-air",
    "open-ended",
    "opened",
    "operatic",
    "operational",
    "operative",
    "opposing",
    "opposite",
    "oppressed",
    "optical",
    "optimal",
    "optimistic",
    "optimum",
    "optional",
    "opulent",
    "orange",
    "orbital",
    "orchestral",
    "ordered",
    "orderly",
    "ordinary",
    "organic",
    "organizational",
    "organized",
    "organizing",
    "oriental",
    "original",
    "ornamental",
    "ornate",
    "orphaned",
    "orthodox",
    "orthopedic",
    "ostensible",
    "ostentatious",
    "other",
    "out-of-town",
    "outdated",
    "outdoor",
    "outer",
    "outgoing",
    "outlandish",
    "outlawed",
    "outlying",
    "outmoded",
    "outraged",
    "outrageous",
    "outright",
    "outside",
    "outspoken",
    "outstanding",
    "outstretched",
    "outward",
    "oval",
    "over-all",
    "over-the-counter",
    "overall",
    "overcast",
    "overcome",
    "overcrowded",
    "overdue",
    "overgrown",
    "overhanging",
    "overhead",
    "overheated",
    "overjoyed",
    "overlapping",
    "overnight",
    "overpowering",
    "overriding",
    "overseas",
    "oversized",
    "overstuffed",
    "overt",
    "overturned",
    "overweight",
    "overwhelming",
    "overworked",
    "packaged",
    "packed",
    "padded",
    "paid",
    "pained",
    "painful",
    "painless",
    "painstaking",
    "painted",
    "palatable",
    "palatial",
    "pale",
    "pallid",
    "palpable",
    "paltry",
    "panicky",
    "papal",
    "paradoxical",
    "parallel",
    "paralyzed",
    "paramilitary",
    "paramount",
    "paranoid",
    "parasitic",
    "parched",
    "parental",
    "parked",
    "parliamentary",
    "parochial",
    "part-time",
    "partial",
    "participating",
    "participatory",
    "particular",
    "partisan",
    "passable",
    "passing",
    "passionate",
    "passive",
    "past",
    "pastel",
    "pastoral",
    "paternal",
    "patient",
    "patriarchal",
    "patriotic",
    "patterned",
    "paved",
    "payable",
    "paying",
    "peace-keeping",
    "peaceable",
    "peaceful",
    "pearly",
    "peculiar",
    "pedagogical",
    "penal",
    "pending",
    "penetrating",
    "penniless",
    "pensive",
    "pent-up",
    "perceived",
    "perceptible",
    "perceptive",
    "perceptual",
    "peremptory",
    "perennial",
    "perfect",
    "perfumed",
    "perfunctory",
    "periodic",
    "peripheral",
    "permanent",
    "permissible",
    "permissive",
    "pernicious",
    "perpetual",
    "perplexed",
    "perplexing",
    "persistent",
    "personal",
    "persuasive",
    "pert",
    "pertinent",
    "pervasive",
    "pessimistic",
    "petite",
    "petrified",
    "petty",
    "petulant",
    "phantom",
    "pharmaceutical",
    "phenomenal",
    "philosophic",
    "philosophical",
    "phonetic",
    "phony",
    "photographic",
    "physical",
    "physiological",
    "pictorial",
    "picturesque",
    "piercing",
    "pinched",
    "pink",
    "pinkish",
    "pioneering",
    "pious",
    "pissed",
    "pitched",
    "pitiful",
    "pitiless",
    "pivotal",
    "placid",
    "plain",
    "plaintive",
    "planetary",
    "planned",
    "planted",
    "plausible",
    "playful",
    "playing",
    "pleasant",
    "pleased",
    "pleasing",
    "pleasurable",
    "pleated",
    "plentiful",
    "pliable",
    "plump",
    "plush",
    "poetic",
    "poignant",
    "pointed",
    "pointless",
    "poisonous",
    "polar",
    "polished",
    "polite",
    "political",
    "polluted",
    "pompous",
    "ponderous",
    "poorly",
    "popular",
    "populist",
    "populous",
    "porous",
    "portable",
    "portentous",
    "portly",
    "posh",
    "positive",
    "possible",
    "post-world",
    "postal",
    "postwar",
    "potent",
    "potential",
    "potted",
    "pouring",
    "powdered",
    "powerful",
    "powerless",
    "practicable",
    "practical",
    "practiced",
    "practicing",
    "pragmatic",
    "precarious",
    "preceding",
    "precious",
    "precipitous",
    "precise",
    "precocious",
    "predatory",
    "predictable",
    "predicted",
    "predominant",
    "preferable",
    "preferential",
    "preferred",
    "prehistoric",
    "prejudiced",
    "preliminary",
    "premier",
    "premium",
    "prenatal",
    "preoccupied",
    "prep",
    "preparatory",
    "prepared",
    "preposterous",
    "prescribed",
    "present",
    "present-day",
    "presentable",
    "preserving",
    "presidential",
    "presiding",
    "pressing",
    "prestigious",
    "presumed",
    "presumptuous",
    "pretentious",
    "pretrial",
    "pretty",
    "prevailing",
    "prevalent",
    "preventive",
    "previous",
    "prewar",
    "priceless",
    "prickly",
    "priestly",
    "prim",
    "primal",
    "primary",
    "prime",
    "primeval",
    "primitive",
    "primordial",
    "princely",
    "principal",
    "printed",
    "prior",
    "pristine",
    "private",
    "privileged",
    "privy",
    "prized",
    "pro",
    "probable",
    "probing",
    "procedural",
    "processed",
    "prodigious",
    "producing",
    "productive",
    "profane",
    "professional",
    "proficient",
    "profitable",
    "profound",
    "progressive",
    "projected",
    "projecting",
    "projective",
    "proletarian",
    "prolific",
    "prolonged",
    "prominent",
    "promiscuous",
    "promised",
    "promising",
    "promotional",
    "prompt",
    "prone",
    "pronounced",
    "proper",
    "prophetic",
    "proportional",
    "proportionate",
    "proposed",
    "proprietary",
    "prosaic",
    "prospective",
    "prosperous",
    "prostrate",
    "protected",
    "protectionist",
    "protective",
    "protracted",
    "protruding",
    "proud",
    "proven",
    "proverbial",
    "provincial",
    "provisional",
    "provocative",
    "prudent",
    "psychedelic",
    "psychic",
    "psychological",
    "pubic",
    "public",
    "public-relations",
    "publicized",
    "published",
    "pudgy",
    "puffing",
    "puffy",
    "pulmonary",
    "pungent",
    "punishable",
    "punishing",
    "punitive",
    "pure",
    "puritanical",
    "purple",
    "purplish",
    "purported",
    "purposeful",
    "pushy",
    "putative",
    "puzzled",
    "puzzling",
    "quaint",
    "qualified",
    "qualifying",
    "qualitative",
    "quantitative",
    "quarterly",
    "queasy",
    "queer",
    "questioning",
    "quick",
    "quiet",
    "quilted",
    "quintessential",
    "quirky",
    "quivering",
    "quixotic",
    "quizzical",
    "rabid",
    "racial",
    "racing",
    "radiant",
    "radical",
    "radioactive",
    "ragged",
    "raging",
    "rainy",
    "raised",
    "rambling",
    "rampant",
    "ramshackle",
    "rancid",
    "random",
    "rapacious",
    "rapid",
    "rapt",
    "rare",
    "rash",
    "rasping",
    "rational",
    "raucous",
    "ravaged",
    "ravenous",
    "raw",
    "reactionary",
    "readable",
    "ready",
    "ready-made",
    "real",
    "real-estate",
    "real-life",
    "realistic",
    "rear",
    "rear-view",
    "rearing",
    "reasonable",
    "reasoned",
    "reassuring",
    "recalcitrant",
    "receding",
    "received",
    "receiving",
    "recent",
    "receptive",
    "reciprocal",
    "reckless",
    "recognizable",
    "recognized",
    "recommended",
    "recorded",
    "recreational",
    "rectangular",
    "recurrent",
    "recurring",
    "red",
    "red-faced",
    "red-haired",
    "red-hot",
    "reddish",
    "reduced",
    "redundant",
    "refined",
    "reflected",
    "reflective",
    "reflex",
    "reformed",
    "reformist",
    "refreshing",
    "regal",
    "regimental",
    "regional",
    "registered",
    "regressive",
    "regular",
    "regulated",
    "regulatory",
    "reigning",
    "related",
    "relative",
    "relaxed",
    "relaxing",
    "released",
    "relentless",
    "relevant",
    "reliable",
    "relieved",
    "religious",
    "reluctant",
    "remaining",
    "remarkable",
    "remedial",
    "remembered",
    "reminiscent",
    "remote",
    "renewed",
    "renowned",
    "rented",
    "repeated",
    "repeating",
    "repetitious",
    "repetitive",
    "replete",
    "reported",
    "reprehensible",
    "representative",
    "repressed",
    "repressive",
    "reproductive",
    "republican",
    "repugnant",
    "reputable",
    "reputed",
    "required",
    "requisite",
    "resentful",
    "reserve",
    "reserved",
    "resident",
    "residential",
    "residual",
    "resigned",
    "resilient",
    "resistant",
    "resolute",
    "resonant",
    "resounding",
    "resourceful",
    "respectable",
    "respected",
    "respectful",
    "respective",
    "respiratory",
    "resplendent",
    "responsible",
    "responsive",
    "restful",
    "restive",
    "restless",
    "restored",
    "restoring",
    "restrained",
    "restraining",
    "restricted",
    "restrictive",
    "resultant",
    "resulting",
    "retail",
    "retaliatory",
    "reticent",
    "retired",
    "retiring",
    "retreating",
    "retroactive",
    "retrospective",
    "returning",
    "revealing",
    "revered",
    "reverent",
    "reverse",
    "revised",
    "revived",
    "revolting",
    "revolutionary",
    "revolving",
    "rewarding",
    "rhetorical",
    "rheumatic",
    "rheumatoid",
    "rhythmic",
    "ribbed",
    "rich",
    "rickety",
    "rife",
    "right",
    "right-hand",
    "right-wing",
    "righteous",
    "rightful",
    "rigid",
    "rigorous",
    "riotous",
    "ripe",
    "ripped",
    "rippling",
    "rising",
    "risky",
    "ritual",
    "rival",
    "roaring",
    "roast",
    "roasted",
    "roasting",
    "robust",
    "rock-and-roll",
    "rocking",
    "rocky",
    "rolled",
    "rolling",
    "romantic",
    "rosy",
    "rotating",
    "rotting",
    "rough",
    "round",
    "round-trip",
    "rounded",
    "rousing",
    "routine",
    "roving",
    "rowdy",
    "royal",
    "rubber",
    "rubbery",
    "ruddy",
    "rudimentary",
    "rueful",
    "ruffled",
    "rugged",
    "ruined",
    "ruinous",
    "ruling",
    "rumpled",
    "run-down",
    "runaway",
    "running",
    "rural",
    "rushing",
    "rusted",
    "rustic",
    "rusty",
    "ruthless",
    "rutted",
    "sacred",
    "sacrificial",
    "sacrosanct",
    "sad",
    "safe",
    "said",
    "saintly",
    "salaried",
    "salient",
    "sallow",
    "salted",
    "salty",
    "salutary",
    "sandy",
    "sane",
    "sanguine",
    "sanitary",
    "sardonic",
    "satiric",
    "satirical",
    "satisfactory",
    "satisfied",
    "satisfying",
    "saturated",
    "saucy",
    "savage",
    "savvy",
    "scaly",
    "scant",
    "scanty",
    "scarce",
    "scared",
    "scarlet",
    "scarred",
    "scary",
    "scathing",
    "scattered",
    "scenic",
    "scented",
    "scheduled",
    "scholarly",
    "scholastic",
    "science-fiction",
    "scientific",
    "scorched",
    "scornful",
    "scrambled",
    "scraping",
    "scrawny",
    "screaming",
    "scriptural",
    "scruffy",
    "scrupulous",
    "sealed",
    "searching",
    "searing",
    "seasonal",
    "seasoned",
    "seated",
    "secluded",
    "second-class",
    "second-floor",
    "second-hand",
    "second-rate",
    "secondary",
    "secondhand",
    "secret",
    "secretarial",
    "secretive",
    "sectarian",
    "sectional",
    "secular",
    "secure",
    "sedate",
    "sedentary",
    "seedy",
    "seeming",
    "segregated",
    "seismic",
    "select",
    "selected",
    "selective",
    "self-appointed",
    "self-assured",
    "self-centered",
    "self-confident",
    "self-conscious",
    "self-contained",
    "self-effacing",
    "self-evident",
    "self-fulfilling",
    "self-help",
    "self-imposed",
    "self-indulgent",
    "self-made",
    "self-proclaimed",
    "self-righteous",
    "self-satisfied",
    "self-serving",
    "self-styled",
    "self-sufficient",
    "self-supporting",
    "selfless",
    "semantic",
    "semifinal",
    "senatorial",
    "senior",
    "sensational",
    "senseless",
    "sensible",
    "sensitive",
    "sensory",
    "sensuous",
    "sentencing",
    "sentimental",
    "separate",
    "separated",
    "separatist",
    "serene",
    "serial",
    "serious",
    "settled",
    "seven-year",
    "seventeenth-century",
    "severe",
    "severed",
    "shabby",
    "shaded",
    "shadowed",
    "shadowy",
    "shady",
    "shaggy",
    "shaken",
    "shaky",
    "shallow",
    "shaped",
    "shapeless",
    "shapely",
    "shared",
    "sharp",
    "sharpened",
    "shattered",
    "shattering",
    "shaven",
    "shaving",
    "sheepish",
    "sheer",
    "sheltered",
    "shifting",
    "shimmering",
    "shining",
    "shiny",
    "shocked",
    "shocking",
    "shoddy",
    "short",
    "short-lived",
    "short-range",
    "short-sleeved",
    "short-term",
    "shortsighted",
    "shouting",
    "showy",
    "shredded",
    "shrewd",
    "shrill",
    "shrinking",
    "shrunken",
    "shuddering",
    "shut",
    "shuttered",
    "shy",
    "sick",
    "sidelong",
    "signed",
    "significant",
    "silent",
    "silken",
    "silky",
    "silly",
    "silver",
    "silver-haired",
    "silvery",
    "similar",
    "simmering",
    "simple",
    "simplified",
    "simplistic",
    "simulated",
    "simultaneous",
    "sincere",
    "sinewy",
    "sinful",
    "single",
    "singular",
    "sinister",
    "sinuous",
    "six-day",
    "six-foot",
    "six-month",
    "six-year",
    "sizable",
    "sizzling",
    "skeletal",
    "skeptical",
    "sketchy",
    "skilled",
    "skillful",
    "skimpy",
    "skinny",
    "skittish",
    "slack",
    "slain",
    "slanted",
    "slatted",
    "sleazy",
    "sled",
    "sleek",
    "sleeping",
    "sleepless",
    "sleepy",
    "sleeveless",
    "slender",
    "sliced",
    "slick",
    "sliding",
    "slight",
    "slim",
    "slimy",
    "slippery",
    "sloping",
    "sloppy",
    "slow",
    "slow-moving",
    "sluggish",
    "sly",
    "small",
    "small-scale",
    "small-time",
    "small-town",
    "smart",
    "smashed",
    "smashing",
    "smiling",
    "smoked",
    "smokeless",
    "smoking",
    "smoky",
    "smoldering",
    "smooth",
    "smug",
    "snap",
    "snappy",
    "snarling",
    "sneaky",
    "snow-covered",
    "snowy",
    "snug",
    "so-called",
    "soaked",
    "soaring",
    "sober",
    "sobering",
    "socalled",
    "sociable",
    "social",
    "socialist",
    "societal",
    "socioeconomic",
    "sociological",
    "sodden",
    "soft",
    "soft-spoken",
    "soggy",
    "soiled",
    "solar",
    "sole",
    "solemn",
    "solicitous",
    "solid",
    "solitary",
    "soluble",
    "somber",
    "sometime",
    "sonic",
    "soothing",
    "sooty",
    "sophisticated",
    "sordid",
    "sore",
    "sorrowful",
    "sorry",
    "sortal",
    "sound",
    "soundless",
    "sour",
    "southeastern",
    "southern",
    "southwestern",
    "sovereign",
    "soybean",
    "spacious",
    "spare",
    "sparkling",
    "sparse",
    "spatial",
    "speaking",
    "special",
    "special-interest",
    "specialized",
    "specific",
    "specified",
    "speckled",
    "spectacular",
    "spectral",
    "speculative",
    "speechless",
    "speeding",
    "speedy",
    "spellbound",
    "spent",
    "spherical",
    "spicy",
    "spiky",
    "spilled",
    "spinal",
    "spindly",
    "spinning",
    "spiral",
    "spirited",
    "spiritual",
    "spiteful",
    "splendid",
    "splintered",
    "split",
    "spoiled",
    "spoken",
    "spongy",
    "sponsored",
    "spontaneous",
    "spooky",
    "sporadic",
    "sporting",
    "sporty",
    "spotless",
    "spotted",
    "spotty",
    "sprawling",
    "spreading",
    "springy",
    "spurious",
    "square",
    "squat",
    "squeaky",
    "stable",
    "stacked",
    "staggering",
    "staid",
    "stained",
    "stained-glass",
    "stainless",
    "stale",
    "stalled",
    "stalwart",
    "stamped",
    "stand-up",
    "standard",
    "standardized",
    "standby",
    "starched",
    "stark",
    "starry",
    "startled",
    "startling",
    "starved",
    "starving",
    "state-owned",
    "state-run",
    "stated",
    "stately",
    "statewide",
    "static",
    "stationary",
    "statistical",
    "statutory",
    "staunch",
    "steadfast",
    "steady",
    "steamed",
    "steaming",
    "steamy",
    "steely",
    "steep",
    "stellar",
    "step-by-step",
    "stepped-up",
    "stereotyped",
    "sticking",
    "sticky",
    "stiff",
    "still",
    "stimulating",
    "stinging",
    "stingy",
    "stinking",
    "stirring",
    "stocky",
    "stolen",
    "stolid",
    "stoned",
    "stony",
    "stopped",
    "stored",
    "stormy",
    "stout",
    "straight",
    "straight-backed",
    "straightforward",
    "strained",
    "stranded",
    "strange",
    "strangled",
    "strapping",
    "strategic",
    "stray",
    "streamlined",
    "strenuous",
    "stressful",
    "stricken",
    "strict",
    "strident",
    "striking",
    "stringent",
    "stringy",
    "striped",
    "strong",
    "strong-willed",
    "structural",
    "structured",
    "struggling",
    "stubby",
    "stuck",
    "studied",
    "studious",
    "stuffed",
    "stuffy",
    "stunned",
    "stunning",
    "stunted",
    "sturdy",
    "stylish",
    "stylistic",
    "stylized",
    "suave",
    "subatomic",
    "subconscious",
    "subdued",
    "subjective",
    "sublime",
    "subliminal",
    "submerged",
    "subordinate",
    "subsequent",
    "subservient",
    "subsidiary",
    "subsidized",
    "substandard",
    "substantial",
    "substantive",
    "substitute",
    "subterranean",
    "subtle",
    "suburban",
    "subversive",
    "succeeding",
    "successful",
    "successive",
    "sudden",
    "suffering",
    "sufficient",
    "suffocating",
    "suggested",
    "suggestive",
    "suicidal",
    "suitable",
    "sullen",
    "sultry",
    "sumptuous",
    "sundry",
    "sunken",
    "sunlit",
    "sunny",
    "super",
    "superb",
    "superficial",
    "superfluous",
    "superhuman",
    "superior",
    "supernatural",
    "supersonic",
    "superstitious",
    "supervisory",
    "supple",
    "supplemental",
    "supplementary",
    "supporting",
    "supportive",
    "supposed",
    "suppressed",
    "supreme",
    "sure",
    "surface-to-air",
    "surgical",
    "surging",
    "surly",
    "surplus",
    "surprised",
    "surprising",
    "surreal",
    "surrounding",
    "surviving",
    "susceptible",
    "suspect",
    "suspected",
    "suspended",
    "suspicious",
    "sustained",
    "swarthy",
    "swaying",
    "sweating",
    "sweeping",
    "sweet",
    "swell",
    "swelling",
    "swift",
    "swinging",
    "swirling",
    "switching",
    "swollen",
    "sworn",
    "symbolic",
    "symmetrical",
    "sympathetic",
    "symptomatic",
    "syndicated",
    "synonymous",
    "syntactic",
    "synthetic",
    "systematic",
    "systemic",
    "tacit",
    "tacky",
    "tactful",
    "tactical",
    "tailored",
    "talented",
    "talkative",
    "tall",
    "tame",
    "tan",
    "tangible",
    "tangled",
    "tanned",
    "tantalizing",
    "tantamount",
    "taped",
    "tart",
    "tasteful",
    "tasteless",
    "tasty",
    "tattered",
    "taut",
    "tawny",
    "tax-exempt",
    "tax-free",
    "taxable",
    "taxing",
    "tearful",
    "teasing",
    "technical",
    "technological",
    "tedious",
    "teeming",
    "teen-age",
    "teenage",
    "telescopic",
    "televised",
    "telling",
    "temperate",
    "temporal",
    "temporary",
    "tempting",
    "ten-year",
    "tenacious",
    "tender",
    "tense",
    "tentative",
    "tenuous",
    "tepid",
    "terminal",
    "terraced",
    "terrestrial",
    "terrible",
    "terrific",
    "terrifying",
    "territorial",
    "terrorist",
    "terse",
    "textured",
    "thankful",
    "thatched",
    "theatrical",
    "thematic",
    "then",
    "theological",
    "theoretical",
    "therapeutic",
    "thermal",
    "thermonuclear",
    "thick",
    "thin",
    "third-floor",
    "thirsty",
    "thorny",
    "thorough",
    "thoughtful",
    "thoughtless",
    "threadbare",
    "threatened",
    "three-day",
    "three-dimensional",
    "three-hour",
    "three-month",
    "three-piece",
    "three-story",
    "three-way",
    "three-week",
    "three-year",
    "thrilled",
    "thrilling",
    "thriving",
    "throaty",
    "throbbing",
    "through",
    "thunderous",
    "thyroid",
    "tidal",
    "tidy",
    "tight",
    "tight-lipped",
    "tiled",
    "time-consuming",
    "time-honored",
    "timeless",
    "timely",
    "timid",
    "tinkling",
    "tinny",
    "tinted",
    "tiny",
    "tional",
    "tired",
    "tireless",
    "tiresome",
    "tiring",
    "tive",
    "token",
    "tolerable",
    "tolerant",
    "toothless",
    "top",
    "top-level",
    "top-secret",
    "topical",
    "topless",
    "tormented",
    "torn",
    "tortuous",
    "tortured",
    "total",
    "touching",
    "touchy",
    "tough",
    "towering",
    "traceable",
    "tracking",
    "traditional",
    "trailing",
    "trained",
    "trampled",
    "tranquil",
    "transatlantic",
    "transcendent",
    "transcendental",
    "transient",
    "transitional",
    "transitory",
    "translucent",
    "transparent",
    "trapped",
    "traumatic",
    "traveling",
    "treacherous",
    "treasured",
    "tree-lined",
    "trembling",
    "tremendous",
    "tremulous",
    "trendy",
    "triangular",
    "tribal",
    "tricky",
    "tried",
    "trifling",
    "trim",
    "triple",
    "trite",
    "triumphal",
    "triumphant",
    "trivial",
    "tropical",
    "troubled",
    "troublesome",
    "troubling",
    "trucking",
    "true",
    "trusted",
    "trusting",
    "trustworthy",
    "truthful",
    "trying",
    "tufted",
    "tumbling",
    "tumultuous",
    "turbulent",
    "turn-of-the-century",
    "turning",
    "turquoise",
    "tutoring",
    "twelve-year-old",
    "twentieth-century",
    "twin",
    "twisting",
    "two-bit",
    "two-day",
    "two-dimensional",
    "two-hour",
    "two-man",
    "two-month",
    "two-room",
    "two-story",
    "two-way",
    "two-week",
    "two-year",
    "typed",
    "typical",
    "tyrannical",
    "ubiquitous",
    "ultimate",
    "ultraviolet",
    "umbilical",
    "unabashed",
    "unable",
    "unaccountable",
    "unaccustomed",
    "unadorned",
    "unaffected",
    "unanimous",
    "unannounced",
    "unanswered",
    "unanticipated",
    "unarmed",
    "unassuming",
    "unattended",
    "unauthorized",
    "unavailable",
    "unavoidable",
    "unaware",
    "unbalanced",
    "unbearable",
    "unbelievable",
    "unborn",
    "unbridled",
    "unbroken",
    "uncanny",
    "uncertain",
    "unchallenged",
    "unchanged",
    "unchanging",
    "uncharacteristic",
    "unchecked",
    "unclean",
    "unclear",
    "uncomfortable",
    "uncommon",
    "uncomplicated",
    "uncomprehending",
    "uncompromising",
    "unconcerned",
    "unconditional",
    "unconscionable",
    "unconscious",
    "unconstitutional",
    "uncontrollable",
    "unconventional",
    "unconvinced",
    "unconvincing",
    "uncritical",
    "uncut",
    "undecided",
    "undefeated",
    "undefined",
    "undeniable",
    "undercover",
    "underdeveloped",
    "underground",
    "underlying",
    "understandable",
    "underwater",
    "undetected",
    "undeveloped",
    "undifferentiated",
    "undisciplined",
    "undisclosed",
    "undiscovered",
    "undisputed",
    "undistinguished",
    "undisturbed",
    "undue",
    "undulating",
    "unearned",
    "unearthly",
    "uneasy",
    "uneducated",
    "unencumbered",
    "unending",
    "unequal",
    "unequivocal",
    "unethical",
    "uneven",
    "uneventful",
    "unexpected",
    "unexplained",
    "unfair",
    "unfamiliar",
    "unfashionable",
    "unfathomable",
    "unfavorable",
    "unfettered",
    "unfinished",
    "unfit",
    "unfocused",
    "unforeseen",
    "unforgettable",
    "unfortunate",
    "unfounded",
    "unfriendly",
    "unfulfilled",
    "ungainly",
    "unguarded",
    "unharmed",
    "unheard",
    "unhurried",
    "unidentified",
    "unified",
    "uniform",
    "uniformed",
    "unifying",
    "unilateral",
    "unimaginable",
    "unimpressed",
    "uninformed",
    "uninhabited",
    "uninhibited",
    "unintelligible",
    "unintended",
    "uninterested",
    "uninteresting",
    "uninterrupted",
    "unionized",
    "unique",
    "unitary",
    "united",
    "universal",
    "unjust",
    "unjustified",
    "unkempt",
    "unknown",
    "unlike",
    "unlikely",
    "unlimited",
    "unlit",
    "unmanageable",
    "unmanned",
    "unmarked",
    "unmatched",
    "unmistakable",
    "unmoved",
    "unmoving",
    "unnamed",
    "unnatural",
    "unnoticed",
    "unobserved",
    "unobtrusive",
    "unoccupied",
    "unofficial",
    "unopened",
    "unorthodox",
    "unpaid",
    "unpainted",
    "unparalleled",
    "unperturbed",
    "unpopular",
    "unprecedented",
    "unpredictable",
    "unprepared",
    "unpretentious",
    "unproductive",
    "unprofitable",
    "unprotected",
    "unpublished",
    "unqualified",
    "unquestioned",
    "unreadable",
    "unreal",
    "unrealistic",
    "unreasonable",
    "unrecognizable",
    "unrecognized",
    "unrelated",
    "unrelenting",
    "unreliable",
    "unresolved",
    "unresponsive",
    "unrestricted",
    "unruffled",
    "unruly",
    "unsafe",
    "unsatisfactory",
    "unsatisfied",
    "unsavory",
    "unscathed",
    "unscrupulous",
    "unseemly",
    "unseen",
    "unsettled",
    "unsettling",
    "unskilled",
    "unsmiling",
    "unsold",
    "unsolved",
    "unsophisticated",
    "unsound",
    "unspecified",
    "unspoiled",
    "unspoken",
    "unstable",
    "unsteady",
    "unsuitable",
    "unsupported",
    "unsure",
    "unsuspecting",
    "untapped",
    "untenable",
    "untested",
    "unthinkable",
    "unthinking",
    "untidy",
    "untimely",
    "untold",
    "untouchable",
    "untouched",
    "untoward",
    "untrained",
    "untreated",
    "untroubled",
    "untrue",
    "unused",
    "unusual",
    "unwanted",
    "unwarranted",
    "unwary",
    "unwashed",
    "unwavering",
    "unwelcome",
    "unwieldy",
    "unwise",
    "unwitting",
    "unwrapped",
    "unwritten",
    "unyielding",
    "up-to-date",
    "upbeat",
    "upcoming",
    "updated",
    "uphill",
    "upper",
    "upper-class",
    "upper-middle-class",
    "uppermost",
    "upright",
    "uprooted",
    "upsetting",
    "upstate",
    "uptight",
    "uptown",
    "upturned",
    "upward",
    "urban",
    "urbane",
    "urgent",
    "usable",
    "used",
    "useful",
    "useless",
    "usual",
    "utilitarian",
    "utmost",
    "utopian",
    "utter",
    "vacant",
    "vague",
    "vain",
    "valiant",
    "valid",
    "valuable",
    "valued",
    "vanished",
    "vanishing",
    "vanquished",
    "variable",
    "varied",
    "various",
    "varying",
    "vascular",
    "vast",
    "vaudeville",
    "vaulted",
    "vaunted",
    "vegetarian",
    "vehement",
    "veiled",
    "velvety",
    "venerable",
    "venereal",
    "venomous",
    "verbal",
    "verifiable",
    "veritable",
    "versatile",
    "vertical",
    "very",
    "vested",
    "veteran",
    "veterinary",
    "viable",
    "vibrant",
    "vice",
    "vice-presidential",
    "vicious",
    "victorious",
    "vigilant",
    "vigorous",
    "vile",
    "vindictive",
    "violet",
    "viral",
    "virile",
    "virtual",
    "virtuous",
    "virulent",
    "visible",
    "visionary",
    "visiting",
    "visual",
    "vital",
    "vivacious",
    "vivid",
    "vocal",
    "vocational",
    "volatile",
    "volcanic",
    "voluble",
    "voluminous",
    "voluntary",
    "voracious",
    "vulnerable",
    "wage-price",
    "waiting",
    "walled",
    "wan",
    "wandering",
    "waning",
    "wanted",
    "wanting",
    "wanton",
    "warlike",
    "warm",
    "warped",
    "warring",
    "wary",
    "washed",
    "wasted",
    "wasteful",
    "watchful",
    "waterproof",
    "watery",
    "waving",
    "wavy",
    "waxed",
    "wayward",
    "weakening",
    "wealthy",
    "weary",
    "weathered",
    "wee",
    "weekly",
    "weeping",
    "weightless",
    "weighty",
    "weird",
    "welcome",
    "welcoming",
    "well",
    "well-defined",
    "well-dressed",
    "well-educated",
    "well-established",
    "well-heeled",
    "well-intentioned",
    "well-known",
    "well-meaning",
    "well-organized",
    "well-placed",
    "well-publicized",
    "well-to-do",
    "well-trained",
    "well-worn",
    "western",
    "whimsical",
    "whipped",
    "whirling",
    "whispered",
    "white",
    "white-collar",
    "white-haired",
    "whitewashed",
    "whitish",
    "whole",
    "wholesale",
    "wholesome",
    "wicked",
    "wide",
    "wide-eyed",
    "wide-open",
    "wide-ranging",
    "widening",
    "widespread",
    "widowed",
    "wild",
    "wild-eyed",
    "willful",
    "willing",
    "wily",
    "winding",
    "windy",
    "winged",
    "winning",
    "winsome",
    "wintry",
    "wiry",
    "wise",
    "wishful",
    "wispy",
    "wistful",
    "withered",
    "withering",
    "withholding",
    "witty",
    "wobbly",
    "wonderful",
    "wondrous",
    "wont",
    "wooded",
    "wooden",
    "woody",
    "woolen",
    "woolly",
    "wordless",
    "workable",
    "working",
    "working-class",
    "world-class",
    "world-wide",
    "worldly",
    "worldwide",
    "worn",
    "worn-out",
    "worrisome",
    "worrying",
    "worsening",
    "worthless",
    "worthwhile",
    "worthy",
    "wounded",
    "woven",
    "wrecked",
    "wretched",
    "wrinkled",
    "written",
    "wrought",
    "wrought-iron",
    "wry",
    "yawning",
    "year-end",
    "year-old",
    "year-round",
    "yearly",
    "yellow",
    "yellowed",
    "yellowing",
    "yellowish",
    "yielding",
    "young",
    "youthful",
    "zealous"
];
